import {useEffect, useState } from "react";
import { Row, Button, Modal, notification, Space, Image } from "antd";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Table, { ColumnsType } from "antd/es/table";

import {
  GlobalTableStyle,
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { DeleteButton, PrimaryButton, RefreshButton } from "../../styled/Button.styled";
import pageSize from "../../../constants/pageSize";
import { useDeleteCommunicationMutation, useGetAllCommunicationQuery } from "../../../feature/Communication/communicationApiSlice";

export default function Communication() {
  const navigate = useNavigate();
  const location = useLocation();
  const { confirm } = Modal;
  const { data, isLoading ,refetch} = useGetAllCommunicationQuery();
  const [deleteComById] = useDeleteCommunicationMutation();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataNew,setData]= useState([])
  const [isRefreshing, setIsRefreshing] = useState(false);
  const viewDetails = (id: number) => {
    navigate(`edit/${id}?page=${currentPage}`, { state: { comId: id } });
  };

  const receivers = [
    {
      label: "Users",
      value: {
        riders: []
      }
    },
    {
      label: "Drivers",
      value: {
        drivers: []
      }
    },
    {
      label: "All",
      value: {
        riders: [],
        drivers: []
      }
    }
  ];
  
  const returName = (item: any) => {
    if (!item) return "All";
    if (item.receiverType) {
      if (item.receiverType === "Users") return "Users";
      if (item.receiverType === "Drivers") return "Drivers";
      if (item.receiverType === "All") return "All";
    }
    const hasRidersKey = Object.prototype.hasOwnProperty.call(item, "riders");
    const hasDriversKey = Object.prototype.hasOwnProperty.call(item, "drivers");

    if (hasRidersKey && !hasDriversKey) return "Users";
    if (hasDriversKey && !hasRidersKey) return "Drivers";
    const hasRiders = Array.isArray(item.riders) && item.riders.length > 0;
    const hasDrivers = Array.isArray(item.drivers) && item.drivers.length > 0;

    if (hasRiders && hasDrivers) return "All";
    if (hasRiders) return "Users";
    if (hasDrivers) return "Drivers";
    return "All";
  }
  
  useEffect(() => {
    if (data && data.data && data.data.content) {
      const myData = data.data.content.map((item: any, index: any) => {
        return { 
          title: item.title,
          description: item.description,
          message: item.message, 
          imageUrl: item.imageUrl,
          name: returName(item), 
          ...item 
        };
      });
      setData(myData);
    }
  }, [data]); 

  const showConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Delete Driver?",
      onOk() {
        onDelete(id);
      },
      onCancel() { },
    });
  };

  const onDelete = (id: number) => {
    deleteComById(id)
      .unwrap()
      .then(() => {
        notification.success({
          message: "Sucessfully Deleted!",
          placement: "bottomLeft",
        });
      })
      .catch((error: any) => {
        notification.error({
          message: "Error",
          description: error.data.message,
          placement: "bottomLeft",
        });
      });
  };

  const columns: ColumnsType<any> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 150,
    },
    {
      title: "Messages",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
    },
    {
      title: "Receiver",
      dataIndex: "name",
      key: "name",
      width: 100,
    },
    {
      title: "Date",
      key: "publishDate",
      dataIndex: "publishDate",
      width: 120,
    },
    {
      title: "Time",
      dataIndex: "publishTime",
      key: "publishTime",
      width: 100,
    },

    {
      key: "key",
      align: "right",
      width: 120,
      render: (record: any) => {
        return (
          <Button
            style={{
              height: "38px",
              background: "#3E4685",
              borderRadius: "5px",
            }}
            type="primary"
            onClick={() => {
              viewDetails(record.id);
            }}
          >
            View Details
          </Button>
        );
      },
    },
    {
      key: "deleteButton",
      width: 80,
      render: (_, record) => (
        <DeleteButton onClick={() => showConfirm(record.id)} />
      ),
    },
  ];

  useEffect(() => {
    refetch(); 
  }, [refetch]);

  useEffect(() => {
    // Restore page from URL when component mounts or when navigating back
    const urlParams = new URLSearchParams(location.search);
    const pageFromUrl = urlParams.get('page');
    if (pageFromUrl) {
      setCurrentPage(parseInt(pageFromUrl, 10));
    }
  }, [location.search]);

  return (
    <>
      <Row justify="end" className="button-bottom-margin">
        <Space>
          <RefreshButton 
            loading={isRefreshing}
            onClick={async () => {
              setIsRefreshing(true);
              await refetch();
              setIsRefreshing(false);
            }} 
          />
          <Link to="add">
            <PrimaryButton> Add </PrimaryButton>
          </Link>
        </Space>
      </Row>
      <LightBlueContainer>
        <WhiteContainer>
          <GlobalTableStyle>
          <Table<any>
           className="transaction-table"
            loading={isLoading}
            columns={columns}
            dataSource={dataNew}
            rowKey="id"
            pagination={{
              pageSize,
              current: currentPage,
              onChange: (page) => {
                setCurrentPage(page);
              },
            }}
          />
          </GlobalTableStyle>
        </WhiteContainer>
      </LightBlueContainer>
    </>
  );
}
